<!--页脚-->
<template>
	<footer class="w c-footer media-components-cfooter">
		<div class="flex t-center c-footer-content">
			<div class=" width-50 c-color-155 c-footer-item">
				<div>
					<div class="text-en">Buy Online</div>
					<div class="text-tip relative">
						<div class="text-tip-div relative">线上购买</div>
						<div class="line c-bg-155"></div>
					</div>
				</div>
				<div class="flex-content-center t-center mg-t-30 pd-t-30 ">
					<div class="relative footer-scan-hover cursor">
						<div class="clear c-footer-icon">
							<img src="./images/14.png" />
						</div>
						<div class="font-24 mg-t-10">天猫店</div>
						
						<img src="./images/tianmao.png" class="showScanImg"/>
					</div>
					<div style="width: 20%;"></div>
					<div class="relative footer-scan-hover cursor">
						<div class="clear c-footer-icon">
							<img src="./images/13.png" />
						</div>
						<div class="font-24 mg-t-10">京东店</div>
						<img src="./images/jingdong.png" class="showScanImg"/>
					</div>
				</div>
			</div>
			<div class="width-50 c-color-155 c-footer-item">
				<div class="text-en">Learn More</div>
				<div class="text-tip relative">
					<div class="text-tip-div relative">了解孕食经验</div>
					<div class="line c-bg-155"></div>
				</div>
				<div class="flex flex-content-center t-center mg-t-30 pd-t-30">
					<!--<div class="c-mg-lr-30">
						<div class="c-footer-scan c-bg-155 br-10">
							<div class="clear">
								<img src="./images/15.png" class="br-10"/>
							</div>
							<div class="font-24 mg-t-10 color-255">公众号</div>
						</div>
					</div>-->
					<div class="c-mg-lr-30 relative footer-scan-hover cursor">
						<div class="clear c-footer-icon">
							<img src="./images/17.png" />
						</div>
						<div class="font-24 mg-t-10">客服</div>
						
						<img src="./images/gongzhonghao.png" class="showScanImg"/>
					</div>
					<div class="c-mg-lr-30 relative footer-scan-hover cursor">
						<div class="clear c-footer-icon">
							<img src="./images/12.png" />
						</div>
						<div class="font-24 mg-t-10">小红书</div>
						
						<img src="./images/xiaohongshu.png" class="showScanImg"/>
					</div>
					<div class="c-mg-lr-30 relative footer-scan-hover cursor">
						<div class="clear c-footer-icon">
							<img src="./images/11.png" />
						</div>
						<div class="font-24 mg-t-10">抖音</div>
						<img src="./images/douyin.png" class="showScanImg"/>
					</div>
				</div>
			</div>
		</div>
		
		<div>
			<img src="./images/16.png" class="c-footer-logo" />
		</div>
		
		<p class="t-center font-14 color-153 copy">©️all rights reserved by a1+momcare lab.<a href="https://beian.miit.gov.cn" target="_blank" class="color-153">浙ICP备2023004097号-1</a></p>
	</footer>
</template>

<script>

	let that;

	export default {

	}
</script>

<style scoped="scoped" lang="scss">
	.c-color-155{color: rgb(155,103,52);}
	.c-bg-155{background-color: rgb(155,103,52);}
	.c-footer{background: rgb(228,224,210);padding: 135px 0 60px 0;}
	.c-footer-content{max-width: 1600px;margin: auto;}
	.text-en{font-size: 22px;font-weight: bold;}
	.text-tip{font-size: 40px;font-weight: bold;letter-spacing: 2px;}
	.text-tip-div{display: inline-block;z-index: 2; padding: 0 20px;background: rgb(228,224,210)}
	.line{width: 80%;height: 4px;position: absolute;top: 50%;margin-top: -2px;left: 50%;transform: translateX(-50%);z-index: 1;
	}
	.c-footer-icon{width: 160px;height: 160px;position: relative;}
	.c-footer-icon img{position: absolute;left: 50%;top: 50%;transform: translate(-50%,-50%);}
	.c-footer-scan{width: 155px;padding: 10px;}
	.c-footer-scan img{width: 100%;}
	.c-mg-lr-50{margin-left: 50px;margin-right: 50px;}
	.c-mg-lr-30{margin-left: 30px;margin-right: 30px;}
	.c-footer-logo{display: block;margin: auto;margin-top: 230px;}
	.copy{margin-top: 160px;}
	
	@media screen and (max-width: 1660px) {
		
	}
	@media screen and (max-width: 1500px) {
		.c-footer-item{zoom: 0.8;}
	}
	@media screen and (max-width: 1300px) {
		.c-footer-item{zoom: 0.7;}
		.c-footer-logo{zoom: 0.7;}
	}
	@media screen and (max-width: 800px) {
		.c-footer-content{display: block;}
		.c-footer-item{width: 95%;margin: auto;padding-top: 65px;}
		.c-mg-lr-30{margin: 0 4px;}
		.c-footer{padding: 0;padding-bottom: 30px;}
		.c-footer-logo{width: 50%;margin-top: 100px;}
		.copy{margin-top: 50px;}
	}
	
	.showScanImg{position: absolute;left: 0;bottom: 0;width: 175px;display: none;}
	.footer-scan-hover:hover .showScanImg{display: block;}
</style>